import { makeRequest } from '../../../../lib/api';
import omit from 'lodash/omit';

const ORDER_PATH = '/v1/orders';
const ORDER_PATH_V2 = '/v2/orders';
const PARTNER_DOC_TEMPLATE = '/v1/partner_doc_templates';
const INSURANCE_DOC_TEMPLATE = '/v1/order_doc_type_statuses';

import {
  GenerateAndSendLinksRequestInterface,
  SendDocSmsRequestInterface,
} from '../../api/printingApi';

const printingController = {
  getPrintingDocumentsResponse: (orderId: string): Promise<any> => {
    // return makeRequest('get', `${ ORDER_PATH }/${ orderId }/docs`);
    return makeRequest('post', `${ ORDER_PATH_V2 }/${ orderId }/docs`);
  },

  getPrintingInsuranceDocumentsResponse: (orderId: string): Promise<any> => {
    return makeRequest('post', `${ INSURANCE_DOC_TEMPLATE }/${ orderId }/summary_doc`, { 'docTypeRefValueIds': [457] });
  },

  getPrintingDocumentsActOfReturnResponse: (orderId: string): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH_V2 }/${ orderId }/docs`, { 'docTypeRefValueIds': [457] });
  },

  generateAndSendLinks: (orderId: string, request: GenerateAndSendLinksRequestInterface ): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH_V2 }/${ orderId }/generate_and_send_links`, request);
  },

  getPlaceholders: (orderId:string): Promise<any> => {
    return makeRequest('get', `${ PARTNER_DOC_TEMPLATE }/placeholders?orderId=${ orderId }`);
  },

  sendDocSms: (request: SendDocSmsRequestInterface ): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH_V2 }/${ request.orderId }/sms_code/verify`, omit(request, ['orderId']));
  },

  getSignedDocUrls: (orderId: string): Promise<any> => {
    return makeRequest('get', `${ ORDER_PATH }/${ orderId }/signed_doc_urls`);
  },

  // предпросмотр PDF-формы: заполнена данными заявки, поля живые (редактируемые)
  getDocPreview: (orderId: string, templateId: string): Promise<any> => {
    return makeRequest('get', `${ ORDER_PATH_V2 }/${ orderId }/docs/${ templateId }/preview`, {}, { responseType: 'arraybuffer' });
  },

  // финальный документ: значения эксперта поверх автозаполнения, поля запечены
  getDocFinal: (orderId: string, templateId: string, userValues: Record<string, string>): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH_V2 }/${ orderId }/docs/${ templateId }/final`, userValues, { responseType: 'arraybuffer' });
  },
};

export { printingController };
